import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateService, getOneService } from 'slice/serviceSlice';
import { useNavigate, useParams } from 'react-router-dom';
import { getUploadUrl } from 'utils/uploadUrl';

const Update = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { loading, oneData } = useSelector((state) => state.service);

    const [name, setName] = useState('');
    const [image, setImage] = useState(null);
    const [pdfFile, setPdfFile] = useState(null);

    useEffect(() => {
        dispatch(getOneService(id));
    }, [dispatch, id]);

    useEffect(() => {
        if (oneData) {
            setName(oneData.name || '');
        }
    }, [oneData]);

    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('name', name);
        if (image) formData.append('image', image);
        if (pdfFile) formData.append('pdfFile', pdfFile);

        dispatch(updateService({ id, data: formData }));
        setTimeout(() => navigate('/khajuraho/services'), 1000);
    };

    return (
        <div className="container-fluid mt-5">
            <div className="mainheadig mx-4">
                <h4 className="text-white font-weight-bold">Update Service</h4>
            </div>
            <form onSubmit={handleSubmit} className="bg-white p-4 mx-4 mt-5 rounded shadow">
                <div className="row">
                    <div className="col-sm-12">
                        <label className="adminlables">
                            Service Name
                            <input type="text" value={name} className="form-control" onChange={(e) => setName(e.target.value)} required />
                        </label>
                    </div>
                    <div className="col-sm-12 mt-3">
                        <label className="adminlables">
                            Image (Leave empty to keep current)
                            <input type="file" accept="image/*" className="form-control" onChange={(e) => setImage(e.target.files[0])} />
                            {oneData?.image && (
                                <div className="mt-2"><img src={getUploadUrl(oneData.image)} alt={oneData.name} style={{ width: '100px' }} /></div>
                            )}
                        </label>
                    </div>
                    <div className="col-sm-12 mt-3">
                        <label className="adminlables">
                            PDF File (Leave empty to keep current)
                            <input type="file" accept="application/pdf" className="form-control" onChange={(e) => setPdfFile(e.target.files[0])} />
                            {oneData?.pdfFile && (
                                <div className="mt-2"><a href={getUploadUrl(oneData.pdfFile)} target="_blank" rel="noopener noreferrer">Current PDF</a></div>
                            )}
                        </label>
                    </div>
                </div>
                <div className="mt-5 text-right">
                    <button className="btn btn-lg updatebtn" disabled={loading}>{loading ? 'Updating...' : 'Update Service'}</button>
                </div>
            </form>
        </div>
    );
};

export default Update;
